export default __webpack_public_path__ + "static/media/9.e2788e23.jpg";